export const ADD_GROUP = 'ADD_GROUP';
export const ADD_GROUP_SUCCESS = 'ADD_GROUP_SUCCESS';
export const ADD_GROUP_FAILED = 'ADD_GROUP_FAILED';
export const RESET_GROUP_CREATED = 'RESET_GROUP_CREATED';
export const FETCH_GROUPS = 'FETCH_GROUPS';
export const FETCH_GROUPS_SUCCESS = 'FETCH_GROUPS_SUCCESS';
export const FETCH_GROUPS_FAILED = 'FETCH_GROUPS_FAILED';
export const RESET_GROUP_UPDATED = 'RESET_GROUP_UPDATED';
export const RESET_GROUP_DELETED = 'RESET_GROUP_DELETED';
export const FETCH_GROUP_PEOPLE = 'FETCH_GROUP_PEOPLE';
export const FETCH_GROUP_PEOPLE_SUCCESS = 'FETCH_GROUP_PEOPLE_SUCCESS';
export const FETCH_GROUP_PEOPLE_FAILED = 'FETCH_GROUP_PEOPLE_FAILED';
export const ADD_PERSON_TO_GROUP = 'ADD_PERSON_TO_GROUP';
export const ADD_PERSON_TO_GROUP_SUCCESS = 'ADD_PERSON_TO_GROUP_SUCCESS';
export const RESET_PERSON_ADDED_TO_GROUP = 'RESET_PERSON_ADDED_TO_GROUP';
export const ADD_PERSON_TO_GROUP_FAILED = 'ADD_PERSON_TO_GROUP_FAILED';
export const REMOVE_PERSON_FROM_GROUP = 'REMOVE_PERSON_FROM_GROUP';
export const REMOVE_PERSON_FROM_GROUP_SUCCESS =
  'REMOVE_PERSON_FROM_GROUP_SUCCESS';
export const REMOVE_PERSON_FROM_GROUP_FAILED =
  'REMOVE_PERSON_FROM_GROUP_FAILED';
export const RESET_PERSON_REMOVED_FROM_GROUP =
  'RESET_PERSON_REMOVED_FROM_GROUP';
export const RENAME_GROUP = 'RENAME_GROUP';
export const RESET_GROUP_PAGE = 'RESET_GROUP_PAGE'
